<div class="commission-page-header">
  <div>
    <h4>
      <i class="fas fa-hand-holding-usd"></i>
      Comissionamento
    </h4>
    <p>Gerencie {{labelOperacionalPlural() | lowercase}} e comissões da sua loja.</p>
  </div>
</div>

<div class="alert alert-danger" *ngIf="erro">{{erro}}</div>
<div class="alert alert-success" *ngIf="sucesso">{{sucesso}}</div>

<div class="commission-operational-card">
  <label>
    <span>Nome operacional</span>
    <input [(ngModel)]="labelComissionados" placeholder="Ex.: Confeiteiros">
  </label>
  <button class="commission-save-name" [disabled]="salvando" (click)="salveLabelComissionados()">
    <i class="fas fa-save"></i>
    Salvar nome
  </button>
</div>

<div class="comissionamento-tabs">
  <button [class.active]="aba === 'comissoes'"
          (click)="selecioneAba('comissoes')">
    <i class="fas fa-tags"></i> Comissões
  </button>
  <button [class.active]="aba === 'comissionados'"
          (click)="selecioneAba('comissionados')">
    <i class="fas fa-user-tie"></i> {{labelOperacionalPlural()}}
  </button>
  <button [class.active]="aba === 'relatorio'"
          (click)="selecioneAba('relatorio')">
    <i class="fas fa-chart-bar"></i> Relatórios
  </button>
</div>

<div class="commission-screen" *ngIf="aba === 'comissoes'">
  <div class="commission-heading">
    <div>
      <span class="commission-eyebrow">Comissões</span>
      <h5>Listagem de comissões</h5>
    </div>
    <div class="commission-heading-actions">
      <button class="btn btn-primary" [disabled]="salvando" (click)="abraNovaComissao()">
        <i class="fas fa-plus"></i>
        Nova comissão
      </button>
      <button class="btn btn-outline-primary" [disabled]="salvando" (click)="abraNovoComissionado()">
        <i class="fas fa-plus"></i>
        Novo {{labelOperacionalSingular() | lowercase}}
      </button>
    </div>
  </div>

  <div class="commission-summary">
    <div class="summary-item">
      <span>Comissões ativas</span>
      <strong>{{totalComissoesAtivas()}}</strong>
    </div>
    <div class="summary-item">
      <span>Produtos vinculados</span>
      <strong>{{totalProdutosVinculados()}}</strong>
    </div>
    <div class="summary-item">
      <span>{{labelOperacionalPlural()}} ativos</span>
      <strong>{{totalComissionadosAtivos()}}</strong>
    </div>
    <div class="summary-item">
      <span>Pendências</span>
      <strong>{{totalComissoesSemProdutos()}}</strong>
    </div>
  </div>

  <div class="commission-content">
    <div class="commission-list">
      <div class="commission-list-title">
        <h5>Comissões cadastradas</h5>
      </div>

      <div class="commission-toolbar">
        <label class="commission-search">
          <i class="fas fa-search"></i>
          <input [(ngModel)]="filtroComissoes.busca" placeholder="Buscar comissão por nome">
        </label>

        <div class="commission-segmented">
          <span>Status</span>
          <button [ngClass]="{'active': filtroComissoes.status === 'todas'}" (click)="altereStatusComissao('todas')">Todas</button>
          <button [ngClass]="{'active': filtroComissoes.status === 'ativas'}" (click)="altereStatusComissao('ativas')">Ativas</button>
          <button [ngClass]="{'active': filtroComissoes.status === 'inativas'}" (click)="altereStatusComissao('inativas')">Inativas</button>
        </div>

        <button class="filter-button" title="Atualizar" kendoTooltip [disabled]="carregando" (click)="carregueComissoes()">
          <i class="fas fa-filter"></i>
        </button>
      </div>

      <div class="commission-table">
        <div class="commission-row commission-row-header">
          <span>Comissão</span>
          <span>Valor fixo</span>
          <span>Produtos</span>
          <span>Status</span>
          <span>Última atualização</span>
          <span class="text-right">Ações</span>
        </div>

        <div class="commission-loading" *ngIf="carregando">
          <i class="k-i k-i-loading"></i>
          <span>Carregando comissões...</span>
        </div>

        <div class="commission-row" *ngFor="let comissao of comissoesFiltradas()" [ngClass]="{'selected': comissaoSelecionada?.id === comissao.id}">
          <strong>{{comissao.nome}}</strong>
          <span>{{comissao.valorFixo | currency:'BRL'}}</span>
          <button class="products-link" [ngClass]="{'pending': totalProdutosDaComissao(comissao) === 0}"
                  (click)="abraProdutosDaComissao(comissao)">
            {{totalProdutosDaComissao(comissao)}} produtos
            <i class="fas fa-exclamation-triangle" *ngIf="totalProdutosDaComissao(comissao) === 0"></i>
          </button>
          <span class="status-pill" [ngClass]="{'active': comissao.ativo && totalProdutosDaComissao(comissao) > 0, 'inactive': !comissao.ativo, 'pending': totalProdutosDaComissao(comissao) === 0}">
            {{totalProdutosDaComissao(comissao) === 0 ? 'Pendente' : (comissao.ativo ? 'Ativa' : 'Inativa')}}
          </span>
          <span>{{textoUltimaAtualizacao(comissao)}}</span>
          <div class="commission-actions">
            <button class="btn btn-outline-primary btn-sm" title="Editar" kendoTooltip (click)="editeComissao(comissao)">
              <i class="fas fa-pen"></i>
              Editar
            </button>
            <button class="btn btn-outline-primary btn-sm" title="Produtos" kendoTooltip (click)="abraProdutosDaComissao(comissao)">
              <i class="fas fa-box-open"></i>
              Produtos
            </button>
          </div>
        </div>

        <div class="commission-empty" *ngIf="!carregando && !comissoesFiltradas().length">
          <i class="fas fa-tags"></i>
          <strong>Nenhuma comissão encontrada</strong>
          <span>Ajuste os filtros ou cadastre uma nova comissão.</span>
        </div>
      </div>

      <div class="commission-warning" *ngIf="totalComissoesSemProdutos() > 0">
        <i class="fas fa-exclamation-triangle"></i>
        <span>{{totalComissoesSemProdutos()}} comissão(ões) sem produtos vinculados</span>
        <button (click)="altereStatusComissao('todas')">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="commission-side-panel">
      <h5>{{labelOperacionalPlural()}}</h5>
      <label class="commission-search side-search">
        <i class="fas fa-search"></i>
        <input [(ngModel)]="buscaComissionadoRapido" placeholder="Buscar {{labelOperacionalPlural() | lowercase}}">
      </label>

      <div class="quick-register">
        <h6>Cadastro rápido</h6>
        <label>
          <span>Nome</span>
          <input class="form-control" [(ngModel)]="comissionadoRapido.nome" placeholder="Ana Souza">
        </label>
        <label>
          <span>Status</span>
          <select class="form-control" [(ngModel)]="comissionadoRapido.ativo">
            <option [ngValue]="true">Ativo</option>
            <option [ngValue]="false">Inativo</option>
          </select>
        </label>
        <button class="btn btn-primary btn-block" [disabled]="salvando" (click)="salveComissionadoRapido()">
          Salvar {{labelOperacionalSingular() | lowercase}}
        </button>
      </div>

      <div class="commissioned-list">
        <div class="commissioned-list-title">
          <strong>Ativos</strong>
        </div>
        <div class="commissioned-row" *ngFor="let comissionado of comissionadosAtivosFiltrados()">
          <span>{{comissionado.nome}}</span>
          <span class="status-pill active">Ativo</span>
          <button class="icon-action" title="Editar" kendoTooltip (click)="editeComissionado(comissionado)">
            <i class="fas fa-pen"></i>
          </button>
        </div>
        <div class="commission-empty small" *ngIf="!comissionadosAtivosFiltrados().length">
          <span>Nenhum {{labelOperacionalSingular() | lowercase}} ativo</span>
        </div>
      </div>

      <button class="side-link" (click)="selecioneAba('comissionados')">
        Ver todos os {{labelOperacionalPlural() | lowercase}}
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>

  <div class="commission-modal-backdrop" *ngIf="modalComissaoAberto">
    <div class="commission-modal" role="dialog" aria-modal="true">
      <div class="commission-modal-header">
        <div>
          <span class="commission-eyebrow">{{comissaoEdicao.id ? 'Editar' : 'Nova'}}</span>
          <h5>{{comissaoEdicao.id ? 'Editar comissão' : 'Nova comissão'}}</h5>
        </div>
        <button class="icon-action" title="Fechar" kendoTooltip (click)="fecheModalComissao()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <label class="w-100">
        <span class="label">Nome</span>
        <input class="form-control" [(ngModel)]="comissaoEdicao.nome" placeholder="Ex.: Confeitaria">
      </label>

      <label class="w-100 mt-3">
        <span class="label">Valor fixo por produto</span>
        <kendo-numerictextbox id="valorFixo" [min]="0" class="form-control" name="valorFixo" #valorFixo=ngModel
                              [format]="'$0.00'" [(ngModel)]="comissaoEdicao.valorFixo" required>
        </kendo-numerictextbox>

        <div class="invalid-feedback">
          <p *ngIf="valorFixo.errors?.required">Valor é obrigatório</p>
        </div>
      </label>

      <label class="commission-switch mt-3">
        <input type="checkbox" [(ngModel)]="comissaoEdicao.ativo">
        <span>Ativa</span>
      </label>

      <div class="commission-modal-actions">
        <button class="btn btn-light" [disabled]="salvando" (click)="fecheModalComissao()">Cancelar</button>
        <button class="btn btn-primary" [disabled]="salvando" (click)="salveComissao()">
          <i class="fas fa-save"></i>
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="commission-modal-backdrop products-modal-backdrop" *ngIf="modalProdutosAberto">
  <div class="products-modal" role="dialog" aria-modal="true">
    <div class="products-modal-header">
      <div>
        <span class="commission-eyebrow">{{modoProdutos === 'vinculados' ? 'Produtos vinculados' : 'Adicionar produtos'}}</span>
        <h5>{{comissaoSelecionada?.nome}}</h5>
        <div class="managed-commission-meta">
          <span>{{comissaoSelecionada?.valorFixo | currency:'BRL'}} por produto</span>
          <span class="status-pill" [ngClass]="{'active': comissaoSelecionada?.ativo, 'inactive': !comissaoSelecionada?.ativo}">
            {{comissaoSelecionada?.ativo ? 'Ativa' : 'Inativa'}}
          </span>
          <span>{{totalProdutosDaComissaoSelecionada()}} produtos vinculados</span>
        </div>
      </div>
      <div class="products-header-actions">
        <button class="btn btn-primary" *ngIf="modoProdutos === 'vinculados'" (click)="abraAdicionarProdutos()">
          <i class="fas fa-plus"></i>
          Adicionar mais produtos
        </button>
        <button class="btn btn-outline-primary" *ngIf="modoProdutos === 'adicionar'" (click)="volteProdutosVinculados()">
          <i class="fas fa-arrow-left"></i>
          Ver vinculados
        </button>
        <button class="icon-action" title="Fechar" kendoTooltip (click)="fecheModalProdutos()">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <div class="products-modal-layout">
      <section class="products-workspace">
        <div class="products-toolbar" *ngIf="modoProdutos === 'adicionar'">
          <label class="commission-search">
            <i class="fas fa-search"></i>
            <input [(ngModel)]="filtroProdutos.busca" (keyup.enter)="carregueProdutos()"
                   placeholder="Buscar produto por nome ou categoria">
          </label>

          <label class="products-category">
            <span>Categoria</span>
            <select class="form-control" [(ngModel)]="filtroProdutos.categoriaId" (ngModelChange)="carregueProdutos()">
              <option [ngValue]="null">Todas</option>
              <option *ngFor="let categoria of categorias" [ngValue]="categoria.id">{{categoria.nome}}</option>
            </select>
          </label>

          <button class="btn btn-primary" [disabled]="!comissaoSelecionada || !filtroProdutos.categoriaId || salvando"
                  (click)="vinculeCategoria()">
            <i class="fas fa-plus"></i>
            Adicionar todos da categoria
          </button>
        </div>

        <div class="products-bulkbar">
          <button class="btn btn-outline-danger" *ngIf="modoProdutos === 'vinculados'"
                  [disabled]="!comissaoSelecionada || totalProdutosSelecionados() === 0 || salvando"
                  (click)="removaSelecionadosDaComissao()">
            <i class="fas fa-trash"></i>
            Remover selecionados
          </button>
          <button class="btn btn-outline-primary" *ngIf="modoProdutos === 'adicionar'"
                  [disabled]="!comissaoSelecionada || totalProdutosSelecionados() === 0 || salvando"
                  (click)="vinculeSelecionados()">
            <i class="fas fa-plus"></i>
            Adicionar selecionados
          </button>
          <button class="btn btn-primary" *ngIf="modoProdutos === 'vinculados'" (click)="abraAdicionarProdutos()">
            <i class="fas fa-plus"></i>
            Adicionar mais produtos
          </button>
          <span class="linked-count">
            <i class="fas fa-check"></i>
            {{totalProdutosDaComissaoSelecionada()}} produtos vinculados
          </span>
        </div>

        <div class="commission-loading" *ngIf="carregandoProdutos">
          <i class="k-i k-i-loading"></i>
          <span>Buscando produtos...</span>
        </div>

        <div class="products-table" *ngIf="!carregandoProdutos">
          <div class="products-row products-row-header">
            <span></span>
            <span>Produto</span>
            <span>Categoria</span>

            <span>Status</span>
            <span class="text-right">Ação</span>
          </div>

          <div class="products-row" *ngFor="let produto of produtosDoModal()">
            <span>
              <input type="checkbox" [(ngModel)]="produtosSelecionados[produto.id]">
            </span>
            <div class="product-cell">
              <div class="product-thumb" [ngClass]="{'empty': !imagemProduto(produto)}">
                <img *ngIf="imagemProduto(produto)" [src]="imagemProduto(produto)" alt="">
                <i *ngIf="!imagemProduto(produto)" class="fas fa-image"></i>
              </div>
              <div>
                <strong>{{produto.nome}}</strong>
                <small>{{produto.codigoPdv || produto.id}}</small>
              </div>
            </div>
            <span>{{produto.categoriaNome || '-'}}</span>

            <span class="status-pill"
                  [ngClass]="{'active': produtoDaComissaoAtual(produto), 'pending': !produto.comissaoId, 'inactive': produtoVinculadoOutraComissao(produto)}">
              {{statusProdutoComissao(produto)}}
            </span>
            <div class="products-actions">
              <button class="btn btn-outline-danger btn-sm" *ngIf="modoProdutos === 'vinculados'"
                      title="Remover da comissão" kendoTooltip (click)="removaProdutoDaComissao(produto)">
                <i class="fas fa-trash"></i>
                Remover
              </button>
              <button class="btn btn-outline-primary btn-sm" *ngIf="modoProdutos === 'adicionar'"
                      title="Adicionar à comissão" kendoTooltip (click)="vinculeProduto(produto)">
                <i class="fas fa-plus"></i>
                Adicionar
              </button>
            </div>
          </div>

          <div class="commission-empty small" *ngIf="!produtosDoModal().length">
            <span>Nenhum produto encontrado</span>
          </div>

          <div class="products-footer" *ngIf="produtosDoModal().length">
            <span>Mostrando {{produtosDoModal().length}} produto(s)</span>
            <span>{{totalProdutosSelecionados()}} selecionado(s)</span>
          </div>
        </div>

        <div class="products-info">
          <i class="fas fa-info-circle"></i>
          <span *ngIf="modoProdutos === 'vinculados'">Ao abrir, esta lista mostra somente produtos já vinculados a esta comissão.</span>
          <span *ngIf="modoProdutos === 'adicionar'">Selecione produtos ainda não adicionados ou adicione uma categoria inteira.</span>
        </div>
      </section>

      <aside class="products-summary-panel">
        <h5>Resumo</h5>
        <div class="products-summary-card">
          <span>Produtos vinculados</span>
          <strong>{{totalProdutosDaComissaoSelecionada()}}</strong>
        </div>
        <div class="products-summary-card">
          <span>Categoria atual</span>
          <strong>{{nomeCategoriaSelecionada()}}</strong>
        </div>
        <div class="products-summary-card">
          <span>Valor da comissão</span>
          <strong>{{comissaoSelecionada?.valorFixo | currency:'BRL'}}</strong>
        </div>
      </aside>
    </div>
  </div>
</div>

<div class="commission-people-screen" *ngIf="aba === 'comissionados'">
  <section class="commission-people-card commission-people-form">
    <div class="commission-card-header">
      <h5>{{comissionadoEdicao.id ? 'Editar' : 'Novo'}} {{labelOperacionalSingular() | lowercase}}</h5>
      <p>Cadastre um novo {{labelOperacionalSingular() | lowercase}} para sua equipe.</p>
    </div>

    <label class="commission-form-field">
      <span>Nome</span>
      <input [(ngModel)]="comissionadoEdicao.nome" placeholder="Ex.: Maria">
    </label>

    <label class="commission-checkbox">
      <input type="checkbox" [(ngModel)]="comissionadoEdicao.ativo">
      <span>{{labelOperacionalSingular()}} ativo na loja</span>
    </label>

    <button class="commission-primary-action" [disabled]="salvando" (click)="salveComissionado()">
      <i class="fas fa-save"></i>
      Salvar
    </button>

    <button class="commission-secondary-action" *ngIf="comissionadoEdicao.id" (click)="comissionadoEdicao = novoComissionado()">
      <i class="fas fa-plus"></i>
      Novo {{labelOperacionalSingular() | lowercase}}
    </button>
  </section>

  <section class="commission-people-card commission-people-list">
    <div class="commission-list-header">
      <div class="commission-card-header">
        <h5>{{labelOperacionalPlural()}}</h5>
        <p>Lista de {{labelOperacionalPlural() | lowercase}} cadastrados.</p>
      </div>
      <label class="commission-toggle">
        <span>Exibir inativos</span>
        <input type="checkbox" [(ngModel)]="filtrosCadastro.incluirComissionadosInativos"
               (ngModelChange)="carregueComissionados()">
        <span class="commission-toggle-track"></span>
      </label>
    </div>

    <div class="commission-people-table">
      <table>
        <thead>
        <tr>
          <th>Nome</th>
          <th>Status</th>
          <th class="text-right">Ações</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let comissionado of comissionados">
          <td><strong>{{comissionado.nome}}</strong></td>
          <td>
            <span class="status-pill" [ngClass]="{'active': comissionado.ativo, 'inactive': !comissionado.ativo}">
              {{comissionado.ativo ? 'Ativo' : 'Inativo'}}
            </span>
          </td>
          <td class="text-right">
            <button class="commission-icon-button" title="Editar" kendoTooltip (click)="editeComissionado(comissionado)">
              <i class="fas fa-pen"></i>
            </button>
            <button class="commission-icon-button danger" title="Remover" kendoTooltip (click)="removaComissionado(comissionado)">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!comissionados.length">
          <td colspan="3" class="commission-empty-cell">Nenhum {{labelOperacionalSingular() | lowercase}} cadastrado</td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<div class="commission-report-screen" *ngIf="aba === 'relatorio'">
  <section class="report-filter-card">
    <div class="report-filter-title">
      <h5>Relatório de comissões</h5>
    </div>

    <div class="report-filter-grid">
      <label>
        <span class="label">Data inicial</span>
        <kendo-datetimepicker class="w-100" [(ngModel)]="filtroRelatorio.inicio"></kendo-datetimepicker>
      </label>

      <label>
        <span class="label">Data final</span>
        <kendo-datetimepicker class="w-100" [(ngModel)]="filtroRelatorio.fim"></kendo-datetimepicker>
      </label>

      <label>
        <span class="label">{{labelOperacionalPlural()}}</span>
        <select class="form-control" [(ngModel)]="filtroRelatorio.comissionado">
          <option [ngValue]="null">Todos</option>
          <option *ngFor="let comissionado of comissionados" [ngValue]="comissionado">{{comissionado.nome}}</option>
        </select>
      </label>

      <label>
        <span class="label">Comissão</span>
        <select class="form-control" [(ngModel)]="filtroRelatorio.comissao">
          <option [ngValue]="null">Todas</option>
          <option *ngFor="let comissao of comissoes" [ngValue]="comissao">{{comissao.nome}}</option>
        </select>
      </label>

      <label>
        <span class="label">Status</span>
        <select class="form-control" [(ngModel)]="filtroRelatorio.status"
                (ngModelChange)="altereStatusRelatorio($event)">
          <option value="validas">Válidas</option>
          <option value="canceladas">Canceladas</option>
          <option value="estornadas">Estornadas</option>
          <option value="todos">Todos</option>
        </select>
      </label>

      <label class="report-switch">
        <span>Incluir canceladas e estornadas</span>
        <input type="checkbox" [ngModel]="incluiCanceladasEstornadas()"
               (ngModelChange)="altereInclusaoCanceladasEstornadas($event)">
      </label>

      <div class="report-filter-actions">
        <button class="btn btn-primary" [disabled]="carregandoRelatorio" (click)="carregueRelatorio()">
          <i class="fas fa-search"></i>
          Filtrar
        </button>
        <button class="btn btn-outline-secondary" [disabled]="carregandoRelatorio" (click)="limpeFiltroRelatorio()">
          <i class="fas fa-undo"></i>
          Limpar
        </button>
      </div>
    </div>
  </section>

  <section class="report-metrics">
    <div class="report-metric-card valid">
      <span class="report-metric-icon"><i class="fas fa-dollar-sign"></i></span>
      <div>
        <span>Total válido</span>
        <strong>{{totalRelatorio() | currency:'BRL'}}</strong>
      </div>
    </div>

    <div class="report-metric-card items">
      <span class="report-metric-icon"><i class="fas fa-cube"></i></span>
      <div>
        <span>Itens no filtro</span>
        <strong>{{totalItensRelatorio()}}</strong>
      </div>
    </div>

    <div class="report-metric-card people">
      <span class="report-metric-icon"><i class="fas fa-users"></i></span>
      <div>
        <span>{{labelOperacionalPlural()}}</span>
        <strong>{{totalComissionadosRelatorio()}}</strong>
      </div>
    </div>

    <div class="report-metric-card canceled">
      <span class="report-metric-icon"><i class="fas fa-exclamation-triangle"></i></span>
      <div>
        <span>Canceladas/Estornadas</span>
        <strong>{{totalRelatorioCanceladasEstornadas() | currency:'BRL'}}</strong>
      </div>
    </div>
  </section>

  <section class="report-results">
    <div class="report-summary-card">
      <div class="report-card-header">
        <h5>Resumo por {{labelOperacionalSingular() | lowercase}}</h5>
      </div>

      <div class="report-summary-table">
        <div class="report-summary-row report-summary-head">
          <span>{{labelOperacionalSingular()}}</span>
          <span>Itens</span>
          <span>Comissões válidas</span>
          <span>Canceladas</span>
          <span>Estornadas</span>
          <span>Total</span>
          <span class="text-right">Ação</span>
        </div>

        <div class="report-summary-row" *ngFor="let linha of resumoPorComissionado(); trackBy: trackByResumoComissionado">
          <strong>{{linha.nome}}</strong>
          <span>{{linha.itens}}</span>
          <span class="money-positive">{{linha.validas | currency:'BRL'}}</span>
          <span class="money-danger">{{linha.canceladas | currency:'BRL'}}</span>
          <span class="money-warning">{{linha.estornadas | currency:'BRL'}}</span>
          <strong class="money-positive">{{linha.total | currency:'BRL'}}</strong>
          <span class="report-summary-actions">
            <button type="button" class="btn btn-outline-primary btn-sm"
                    (click)="abraDetalhesRelatorio(linha, $event)">
              <i class="fas fa-list"></i>
              Detalhes
            </button>
          </span>
        </div>

        <div class="commission-empty small" *ngIf="!resumoPorComissionado().length">
          <span>Nenhum lançamento encontrado no período</span>
        </div>
      </div>
    </div>
  </section>

  <div class="report-info">
    <i class="fas fa-info-circle"></i>
    <span>Canceladas e estornadas aparecem separadas dos totais válidos.</span>
  </div>

  <div class="commission-modal-backdrop products-modal-backdrop report-detail-backdrop" *ngIf="modalDetalhesRelatorioAberto">
    <div class="products-modal report-detail-modal" role="dialog" aria-modal="true">
      <div class="products-modal-header">
        <div>
          <span class="commission-eyebrow">Detalhamento por pedido e item</span>
          <h5>{{comissionadoDetalheRelatorio?.nome}}</h5>
          <div class="managed-commission-meta">
            <span>{{relatorioDetalheSelecionado.length}} lançamento(s)</span>
            <span>{{comissionadoDetalheRelatorio?.itens}} item(ns) no filtro</span>
            <span>{{comissionadoDetalheRelatorio?.total | currency:'BRL'}} válido</span>
          </div>
        </div>
        <button class="icon-action" title="Fechar" kendoTooltip (click)="fecheDetalhesRelatorio()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="report-detail-modal-body">
        <div class="report-grid-toolbar">
          <h5>Detalhamento por pedido e item</h5>
          <div class="report-export-actions">
            <button type="button" class="btn btn-outline-primary btn-sm"
                    [disabled]="!relatorioDetalheSelecionado.length"
                    (click)="exporteRelatorioCsv()">
              <i class="fas fa-file-csv"></i>
              Exportar CSV
            </button>
          </div>
        </div>

        <div class="report-detail-table">
          <table>
            <thead>
            <tr>
              <th>Data</th>
              <th>Pedido</th>
              <th>Produto</th>
              <th>Comissão</th>
              <th>Qtd</th>
              <th>Valor fixo</th>
              <th>Valor calculado</th>
              <th>Status</th>
              <th>{{labelOperacionalSingular()}}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let linha of relatorioDetalheSelecionado">
              <td>{{linha.dataProducao | date:'dd/MM/yyyy HH:mm'}}</td>
              <td><strong class="order-code">#{{codigoPedidoRelatorio(linha)}}</strong></td>
              <td>{{linha.nomeProduto}}</td>
              <td>{{linha.nomeComissao}}</td>
              <td>{{linha.quantidade}}</td>
              <td>{{linha.valorComissaoFixa | currency:'BRL'}}</td>
              <td>{{linha.valorCalculado | currency:'BRL'}}</td>
              <td>
                <span class="status-pill" [ngClass]="classeStatusRelatorio(linha.status)">
                  {{textoStatusRelatorio(linha.status)}}
                </span>
              </td>
              <td>{{linha.nomeComissionado}}</td>
            </tr>
            <tr *ngIf="!relatorioDetalheSelecionado.length">
              <td colspan="9" class="commission-empty-cell">Nenhum lançamento encontrado</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
